import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';
import Upgrade from './Upgrade.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/upgrade'),
      component: SettingsContent,
      meta: {
        permissions: ['administrator'],
      },
      props: {
        headerTitle: 'UPGRADE_SETTINGS.TITLE',
        icon: 'sparkles',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'settings_upgrade_index',
          component: Upgrade,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
